export default __webpack_public_path__ + "static/media/reply-comment.079b3c54.svg";